/* eslint-disable no-return-await */
/* eslint-disable no-useless-constructor */
import axios from 'axios';

import config from 'config.json';
import { AuthentificationModel } from 'core/models/authentification.model';
import { StatusCodes } from 'http-status-codes';
import { BaseService } from 'core/services/base.abstract.service';

export class OAuth2Service extends BaseService {
  constructor(env) {
    super(env);
  }

  authorize = (origin, state) => {
    window.location = `${this.apiUrl}/api/oauth2/authorize?response_type=code&client_id=tactileoplayer&redirect_uri=${origin}&state=${state}`;
  };

  getAuth = async (code) => {
    return await axios
      .post(
        `${this.apiUrl}/api/oauth2/token`,
        new URLSearchParams({
          grant_type: 'authorization_code',
          code,
          client_id: config.CLIENT_ID,
        }),
      )
      .then(async (res) => {
        const bo = await res?.data;
        if (res.status === StatusCodes.OK) {
          return new AuthentificationModel(bo);
        }
        throw new Error(bo.error);
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
}
